import styled from 'styled-components';

import { ACQ, ANIM, COLORS } from '@/nova/theme/tokens';

/** Segmented mode tabs (Email / Shareable link), matching the Ads Budget modal's in-sheet tabs: a
 *  dark inset track holding equal-width tabs, the active one lifted with a subtle fill + bolder text. */
export const ModeTabs = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  padding: 6px;
  border-radius: 14px;
  background: ${ACQ.tabRow};
`;

export const ModeTab = styled.button<{ $active: boolean }>`
  flex: 1 1 0;
  appearance: none;
  border: none;
  font-family: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  font-size: 14px;
  font-weight: ${(p) => (p.$active ? 700 : 500)};
  color: ${(p) => (p.$active ? COLORS.heading : COLORS.textMuted)};
  background: ${(p) => (p.$active ? ACQ.tabActiveBg : 'transparent')};
  border-radius: 10px;
  cursor: pointer;
  white-space: nowrap;
  transition:
    background ${ANIM.INTERACT_MS}ms ease,
    color ${ANIM.INTERACT_MS}ms ease;

  &:hover {
    color: ${COLORS.heading};
  }
`;

/** The freshly-minted invite link: a muted rounded box with the URL and a copy action. */
export const LinkBox = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  border-radius: 10px;
  background: ${COLORS.surfaceMuted};
`;

export const LinkText = styled.span`
  flex: 1;
  min-width: 0;
  font-size: 12px;
  color: ${COLORS.text};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
